module.exports = __webpack_public_path__ + "assets/icon_order_management_grey.91ce3b1f.svg";